import { Subtitle1, Title2 } from '@fluentui/react-components';
import {
	Games24Filled,
	News24Filled,
	Form24Filled,
	MegaphoneLoud24Filled
} from '@fluentui/react-icons';
import { Dispatch, SetStateAction } from 'react';
import { ResourceTypes } from '../Api/Story/types';

import './ResourceSelector.scss';

interface ResourceSelectorProps {
	value: ResourceTypes | undefined;
	setValue: Dispatch<SetStateAction<ResourceTypes | undefined>>;
}

export default function ResourceSelector(props: ResourceSelectorProps) {
	return (
		<div className={'root'}>
			<Title2>Select a Resource</Title2>

			<div className={'group'}>
				<div
					className={`item ${
						props.value === ResourceTypes.Game ? 'active' : ''
					}`}
					onClick={() => {
						props.setValue(ResourceTypes.Game);
					}}
				>
					<Subtitle1>Video Game</Subtitle1>
					<Games24Filled />
				</div>

				<div
					className={`item ${
						props.value === ResourceTypes.Story ? 'active' : ''
					}`}
					onClick={() => {
						props.setValue(ResourceTypes.Story);
					}}
				>
					<Subtitle1>Story</Subtitle1>
					<News24Filled />
				</div>
			</div>

			<div className={'group'}>
				<div
					className={`item ${
						props.value === ResourceTypes.Review ? 'active' : ''
					}`}
					onClick={() => {
						props.setValue(ResourceTypes.Review);
					}}
				>
					<Subtitle1>Review</Subtitle1>
					<Form24Filled />
				</div>

				<div
					className={`item ${
						props.value === ResourceTypes.Custom ? 'active' : ''
					}`}
					onClick={() => {
						props.setValue(ResourceTypes.Custom);
					}}
				>
					<Subtitle1>Custom</Subtitle1>
					<MegaphoneLoud24Filled />
				</div>
			</div>
		</div>
	);
}
